"use client";

import React, { createContext, useContext, ReactNode } from "react";
import { isEmpty } from "@/utils/lodash";

interface LocaleContextType {
  getLabel: (label: string, defaultVi?: string, defaultEn?: string, lang?: string) => string;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

export const useLocalContext = () => {
  const context = useContext(LocaleContext);
  if (!context) {
    return {
      getLabel: (label: string) => label,
      t: (label: string) => label
    };
  }
  return {
    ...context,
    t: context.getLabel
  };
};

export const useLocale = useLocalContext;

export const LocaleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const getLabel = (label: string, defaultVi = "", defaultEn = "", lang = "vi") => {
    if (!label) return "";
    
    // Simple implementation based on user's request
    // This can be expanded later to fetch from API as the user's code suggested
    return label;
  };

  const value = {
    getLabel,
  };

  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
};
